module.exports = __webpack_public_path__ + "img/img2.e419f658.jpg";